const ModelOpenWO = function (root, store) {
  return {
    id: null,
    rfqID: null,
    rfq2ID: null,
    customerCompanyID: null,
    po: null,
    baxpo: null,
    supplierCompanyID: null,
    supplierContactID: null,
    partID: null,
    partSN: '',
    price: null,
    conditionID: null,
    currencyID: null,
    customerCompanyDetailID: null,
    customerContactID: null,
    poDate: null,
    requestedDate: null,
    rfqTypeID: null,
    baxEmployeeID: null,
    poIsOpen: false,
    shipToCompanyID: null,
    shipToContactID: null,
    shipToCompanyDetailID: null,
    customerForwarderID: null,
    priorityID: null,
    orderRatingScoreID: null,
    paymentTermID: null,
    observation: '',
    receivedDate: null,
    estimatedDeliveryDate: null,
    quoteDate: null,

    orderPhaseID: null,
    phaseDate: null,
    phasePersonInChargeEmployeeID: null,
    lastInfo: '',
    shipped: false,
    shippedDate: null,
    quoteReceived: false,
    quoteReceivedDate: null,
    quoteApproved: false,
    quoteApprovedDate: null,
    unitShipped: false,
    unitShippedDate: null,
    standby: '',
    standbyDate: null,
    reminderDate: null
  }
}
const ModelOpenPO = function (root, store) {
  return {
    id: null,
    rfqID: null,
    rfq2ID: null,
    customerCompanyID: null,
    po: null,
    baxpo: null,
    supplierCompanyID: null,
    supplierContactID: null,
    partID: null,
    partSN: '',
    price: null,
    conditionID: null,
    currencyID: null,
    customerCompanyDetailID: null,
    customerContactID: null,
    poDate: null,
    requestedDate: null,
    rfqTypeID: null,
    baxEmployeeID: null,
    poIsOpen: false,
    shipToCompanyID: null,
    shipToContactID: null,
    shipToCompanyDetailID: null,
    customerForwarderID: null,
    priorityID: null,
    orderRatingScoreID: null,
    paymentTermID: null,
    observation: '',
    receivedDate: null,
    estimatedDeliveryDate: null,

    orderPhaseID: null,
    phaseDate: null,
    phasePersonInChargeEmployeeID: null,
    lastInfo: '',
    shipped: false,
    shippedDate: null,
    quoteReceived: false,
    quoteReceivedDate: null,
    quoteApproved: false,
    quoteApprovedDate: null,
    unitShipped: false,
    unitShippedDate: null,
    standby: '',
    standbyDate: null,
    reminderDate: null
  }
}
const ModelEmailStatusRequest = function (root, state) {
  return {
    subject: null,
    salesOrderContactName: null,
    baxPO: null,
    partNumber: null,
    partSN: null,
    lastInfo: null
  }
}
const ModelEmailNewInstruction = function (root, state) {
  return {
    subject: null,
    baxPO: null,
    partNumber: null,
    partSN: null,
    listActivities: null,
    lastInfo: null
  }
}
const MainModel = function (root, store) {
  return {
    ...ModelOpenWO(root, store),
    ...ModelOpenPO(root, store)
  }
}
export {
  MainModel,
  ModelOpenWO,
  ModelOpenPO,
  // Emails
  ModelEmailStatusRequest,
  ModelEmailNewInstruction
}
